import CrudPage, { fmtMoney } from "../components/CrudPage";
import { UsersThree } from "@phosphor-icons/react";

const CUR_OPTS = [
  { value: "TRY", label: "₺ TRY" }, { value: "USD", label: "$ USD" }, { value: "EUR", label: "€ EUR" }, { value: "GBP", label: "£ GBP" },
];

export default function Contacts() {
  return (
    <CrudPage
      title="Cari Hesaplar"
      subtitle="Müşteri ve tedarikçileriniz"
      endpoint="contacts"
      exportEntity="contacts"
      emptyIcon={UsersThree}
      testidPrefix="cari"
      fields={[
        { name: "name", label: "Ünvan / İsim" },
        { name: "type", label: "Tür", type: "select", default: "customer", options: [{ value: "customer", label: "Müşteri" }, { value: "supplier", label: "Tedarikçi" }] },
        { name: "email", label: "E-posta" },
        { name: "phone", label: "Telefon" },
        { name: "currency", label: "Para Birimi", type: "select", default: "TRY", options: CUR_OPTS },
        { name: "balance", label: "Bakiye (+ alacak / - borç)", type: "number" },
      ]}
      columns={[
        { key: "name", label: "Ünvan" },
        { key: "type", label: "Tür", render: (i) => (
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${i.type === "customer" ? "bg-blue-500/15 text-blue-400" : "bg-purple-500/15 text-purple-400"}`}>
            {i.type === "customer" ? "Müşteri" : "Tedarikçi"}
          </span>
        ) },
        { key: "email", label: "E-posta" },
        { key: "phone", label: "Telefon" },
        { key: "balance", label: "Bakiye", align: "right", render: (i) => (
          <span className={i.balance >= 0 ? "text-emerald-400" : "text-rose-400"}>{fmtMoney(i.balance, i.currency)}</span>
        ) },
      ]}
    />
  );
}
